import Reveal from '@/components/feature/Reveal';
import SectionHeading from './SectionHeading';
import { testimonials } from '@/mocks/guide';

const principles = [
  { icon: 'ri-search-eye-line', title: '先核实，再表达', desc: '任何线索在公开前都要经过交叉核查，宁可慢一步，也不让未经证实的信息扩散。' },
  { icon: 'ri-shield-user-line', title: '保护投稿人', desc: '身份信息与稿件分开存放，投稿人可以自主决定联系方式是否对编辑之外的任何人可见。' },
  { icon: 'ri-book-open-line', title: '讲清楚规矩', desc: '把格式、流程、注意事项写在明面上，让投稿这件事不再靠猜。' },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="ABOUT US"
          title="关于爆料51"
          desc="爆料51 是一个面向公众的信息投稿平台，把散落在个人手中的线索，整理成可核实、可跟进的内容。我们希望投稿这件事有章可循，也希望每一位投稿人的顾虑都被认真对待。"
          align="center"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {principles.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="h-full p-6 rounded-lg bg-background-100 border border-background-200">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 md:mt-16">
          <Reveal>
            <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground-950">
              投稿人的真实反馈
            </h3>
            <p className="mt-2 text-sm text-foreground-600">以下反馈来自通过指南完成投稿的用户，内容已获授权并做匿名化处理。</p>
          </Reveal>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {testimonials.map((item, index) => (
              <Reveal key={item.name} delay={index * 90}>
                <blockquote className="h-full flex flex-col p-6 rounded-lg bg-secondary-50 border border-secondary-200">
                  <i className="ri-double-quotes-l text-2xl text-secondary-400" aria-hidden="true" />
                  <p className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">{item.quote}</p>
                  <footer className="mt-5 pt-4 border-t border-secondary-200">
                    <p className="font-heading font-medium text-sm text-foreground-950">{item.name}</p>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.role}</p>
                  </footer>
                </blockquote>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}